<template>
  <InputBase
    type="datetime-local"
    :id="id"
    :autofocus="props.autofocus"
    v-model="localValue"
    :error="props.error"
    :autocomplete="props.autocomplete"
    :name="props.label"
    :disabled="props.disabled"
  />
</template>

<script setup>
import { computed } from 'vue'
import InputBase from './InputBase.vue'

const emits = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: [String, Number],
  error: String,
  autofocus: Boolean,
  autocomplete: String,
  name: String,
  id: String,
  required: Boolean,
  disabled: Boolean,
})

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})
</script>
